<canvas id="color-strip" class="zone-strip" (mousedown)="onMousedown($event)" (mouseup)="onMouseup($event)"
 width="15" height="200"></canvas>